/// Реєстр підписок на дії клавіатури.
///
/// Окремо від провайдера — і не тому, що лінтер попросив: модульний реєстр
/// поруч із компонентом ламає Fast Refresh, а каса відкрита цілу зміну, і
/// перезавантаження сторінки означає втрачений кошик.
///
/// Не контекст: підписка через Map не змушує сусідні екрани перемальовуватись,
/// коли касир натиснув цифру.

import type { PosAction } from '@/shared/domain/hotkeys'

type Handler = (payload: { slot?: number }) => void

const handlers = new Map<PosAction, Set<Handler>>()
const scanHandlers = new Set<(code: string) => void>()

/// Підписка екрана на дію. Повертає функцію відписки — для `useEffect`.
export const onHotkey = (action: PosAction, handler: Handler) => {
  const set = handlers.get(action) ?? new Set()
  set.add(handler)
  handlers.set(action, set)
  return () => set.delete(handler)
}

export const onScan = (handler: (code: string) => void) => {
  scanHandlers.add(handler)
  return () => scanHandlers.delete(handler)
}

export const dispatchHotkey = (action: PosAction, payload: { slot?: number }): void => {
  handlers.get(action)?.forEach((handler) => handler(payload))
}

export const dispatchScan = (code: string): void => {
  scanHandlers.forEach((handler) => handler(code))
}
